// @flow

/**
 * Module dependencies.
 */

import { withSticky } from 'client/components/core/sticky-navbar/with-sticky';
import React from 'react';
import Waypoint from 'react-waypoint';

/**
 * `Props` type.
 */

type Props = {
  children: React$Element<*>,
  setSticky: Function
};

/**
 * `StickyNavbarTrigger` component.
 */

function StickyNavbarTrigger(props: Props): React$Element<*> {
  const { children, setSticky } = props;

  const onEnter = ({ previousPosition }) => {
    return previousPosition === 'above' ? setSticky(false) : false;
  };

  const onLeave = ({ currentPosition }) => {
    return currentPosition === 'above' ? setSticky(true) : false;
  };

  return (
    <div>
      <Waypoint
        onEnter={onEnter}
        onLeave={onLeave}
      />

      <div>{children}</div>
    </div>
  );
}

/**
 * Export `StickyNavbarTrigger`.
 */

export default withSticky(StickyNavbarTrigger);



// WEBPACK FOOTER //
// ../src/client/components/core/sticky-navbar/sticky-navbar-trigger.js